module.exports = require("github:dbushell/Pikaday@1.5.1/pikaday.js");